/**
 * Gets the values of a form element in object format, based on names.
 *
 * @param form Form element to extract values from.
 *
 * @example
 * <form ref={formRef}>
 *   <input name="foo" value="bar" />
 * </form>
 *
 * getFormValues(formRef.current);
 * // { foo: 'bar' }
 */
export function getFormValues(form) {
    const elementsByName = groupBy(Array.from(form.elements), (el) => el.name || '');
    return Object.fromEntries(Object.entries(elementsByName)
        .filter(([name]) => name)
        .map(([name, elements]) => [name, getValue(elements)]));
}
const groupBy = (array, keyFn) => array.reduce((obj, item, index) => {
    var _a;
    const key = keyFn(item, index);
    ((_a = obj[key]) !== null && _a !== void 0 ? _a : (obj[key] = [])).push(item);
    return obj;
}, {});
function getValue(elements) {
    var _a;
    if (elements.some(isRadio))
        return valueOf(elements.find((el) => el.checked));
    if (elements.length > 1)
        return elements.map(valueOf).filter(Boolean);
    const [element] = elements;
    if (isSelectMultiple(element))
        return Array.from((_a = element.options) !== null && _a !== void 0 ? _a : [])
            .filter((opt) => opt.selected)
            .map((opt) => opt.value);
    return valueOf(element);
}
function valueOf(el) {
    var _a;
    if (!el)
        return null;
    if (isCheckbox(el))
        if (!el.hasAttribute('value'))
            return el.checked;
        else
            return el.checked ? el.value : null;
    if (isRadio(el))
        return el.value || '';
    if (isNumber(el))
        return ((_a = el.value) === null || _a === void 0 ? void 0 : _a.length) ? toNumber(el.value) : null;
    return el.value;
}
const isCheckbox = (el) => el.type === 'checkbox';
const isNumber = (el) => el.type === 'number';
const isRadio = (el) => el.type === 'radio';
const isSelectMultiple = (el) => el.multiple;
const toNumber = (value) => (+value === 0 ? 0 : +value || null);
//# sourceMappingURL=getFormValues.js.map